/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".ui-table-caption[_ngcontent-%COMP%]{background-color:#fff}@media screen{#print-content[_ngcontent-%COMP%], .print-content[_ngcontent-%COMP%]{display:none!important;visibility:hidden!important}}html[_ngcontent-%COMP%]{font-family:Montserrat,sans-serif!important}"];
export { styles as styles };

